import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  useMediaQuery,
} from "@mui/material";
import Filter from "./Filter.mp4"; // Adjust path if necessary
import FilterListIcon from '@mui/icons-material/FilterList';

const FilterSection = ({ onFilterChange }) => {
  const isMobile = useMediaQuery("(max-width:600px)");

  const [filters, setFilters] = useState({
    strongBuy: "",
    buy: "",
    volume: "",
    newsKeyword: "",
    undervalued: false,
    rank: "",
  });

  // Update filters and notify parent component
  const handleFilterChange = (field, value) => {
    const updatedFilters = { ...filters, [field]: value };
    setFilters(updatedFilters);
    onFilterChange(updatedFilters); // Notify parent component with updated filters
  };

  return (
    <Box
      sx={{
        position: "relative",
        
        minHeight: "10vh",
        overflow: "hidden",
        backgroundColor: "#000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "20px",
        gap: "16px",
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          objectFit: "cover",
          opacity: 0.7,
        }}
      >
        <source src={Filter} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.6)",
        }}
      />

      {/* Title */}
      <Typography
        variant="h4"
        sx={{
          zIndex: 1,
          color: "#fff",
          fontWeight: "bold",
          fontFamily: "'Work Sans', sans-serif",
          letterSpacing: "2px",
          marginBottom: "16px",
        }}
      >
        <FilterListIcon
          sx={{
            fontSize: "2rem",
            verticalAlign: "middle",
            marginRight: "8px",
          }}
        />
        Market Filters
      </Typography>

      {/* Filters Grid */}
      <Grid
        container
        spacing={3}
        justifyContent="center"
        sx={{
          zIndex: 1,
          maxWidth: isMobile ? "100%" : "80%",
        }}
      >
        {/* Each filter input */}
        {[
          { label: "Strong Buy Rating >", field: "strongBuy", type: "number" },
          { label: "Buy Rating >", field: "buy", type: "number" },
          { label: "Volume >", field: "volume", type: "number" },
          { label: "News Contains", field: "newsKeyword", type: "text" },
          { label: "Points >", field: "rank", type: "text" },
        ].map((filter, index) => (
          <Grid
            key={index}
            item
            xs={11}
            sm={6}
            md={2}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <TextField
              fullWidth
              label={filter.label}
              variant="outlined"
              size="small"
              type={filter.type}
              value={filters[filter.field]}
              onChange={(e) => handleFilterChange(filter.field, e.target.value)}
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "8px",
                color: "white",
                "& .MuiInputBase-root": {
                  fontFamily: "'Work Sans', sans-serif",
                  color: "white",
                },
                "& .MuiInputLabel-root": {
                  color: "lightgray",
                  fontFamily: "'Work Sans', sans-serif",
                },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "lightblue",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "lightblue",
                  },
                },
              }}
            />
          </Grid>
        ))}
      </Grid>

      {/* Undervalued Checkbox */}
      <Box
        sx={{
          zIndex: 1,
          display: "flex",
          justifyContent: "center",
          width: "100%",
          marginTop: "16px",
        }}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={filters.undervalued}
              onChange={(e) =>
                handleFilterChange("undervalued", e.target.checked)
              }
              sx={{
                color: "white",
                "&.Mui-checked": { color: "lightblue" },
              }}
            />
          }
          label={
            <Typography
              sx={{
                color: "white",
                fontFamily: "'Work Sans', sans-serif",
              }}
            >
              Undervalued Only
            </Typography>
          }
        />
      </Box>
    </Box>
  );
};

export default FilterSection;
